import React, { useState } from "react";
import { useStepper } from "../../Stepper";
import Button from "components/Button";
import { useConfirm } from "components/Confirm";
import { useFullScreenSpinner } from "components/FullScreenSpinner";
import apiRequest from "utils/apiRequest";
import { colors } from "styles";
import * as Sentry from "@sentry/react";
import parseDataBeforeSending from "utils/parseDataBeforeSending";
import analytics from "utils/analytics";
import { redirect } from "utils/windowRelocation";

const TalkToAgentButton = ({ buttonProps }) => {
  const { getDefault } = useStepper();
  const { open } = useConfirm();
  const { isLoading, showSpinner, hideSpinner } = useFullScreenSpinner();
  const [error, setError] = useState(null);

  const talkToAgent = async () => {
    showSpinner("Procesando... Espere por favor (no cierre la aplication).");

    try {
      const { firstName, lastName, email, phoneNumber } =
        getDefault("personalInfo");
      const data = {
        firstName: firstName || lastName,
        lastName: lastName || firstName,
        email,
        phoneNumber,
        fixReasons: getDefault("reason"),
        currentCreditScore: getDefault("currentScore"),
        problemsAffectingScore: getDefault("currentProblems").join(","),
        selectedRecommendations:
          getDefault("recommendations").selectedOptions.join(","),
      };
      const parsedData = parseDataBeforeSending(data);

      try {
        await apiRequest("POST", "/lead", parsedData);

        analytics.sendEvent("lead");

        redirect("/especialista");
      } catch (error) {
        Sentry.captureMessage(`Cannot create Lead`, {
          extra: {
            error,
            errorMsg: error?.message || "N/A",
            data,
            parsedData,
          },
          level: Sentry.Severity.Error,
        });

        setError(
          error?.type === "email-exists"
            ? `El email "${email}" que ha ingresado ya esta en uso.`
            : "Ha ocurrido un error. Por favor intentelo nuevamente o contacte soporte tecnico"
        );

        hideSpinner();
      }
    } catch (error) {
      Sentry.captureMessage(`Especialist submit handler`, {
        extra: {
          error,
          errorMsg: error?.message || "N/A",
        },
        level: Sentry.Severity.Error,
      });

      setError(
        "Ha ocurrido un error. Por favor intentelo nuevamente o contacte soporte tecnico"
      );
    }
  };

  return (
    <>
      <Button
        $type="tertiary"
        disabled={isLoading}
        onClick={() => {
          open(
            <>
              <p>
                Luego de precionar el boton "Continuar" no podra volver para
                atras y hacer cambios hasta ser contactado por un especialista.
              </p>
              <p>
                Lo pondremos en contacto con un especialista en las proximas 24
                horas.
              </p>
            </>,
            () => {
              talkToAgent();
            }
          );
        }}
        children="Hablar con Especialista"
        {...buttonProps}
      />

      {error && (
        <div
          style={{
            color: colors.white,
            backgroundColor: colors.red,
            padding: 20,
            textAlign: "center",
            fontSize: "1.2em",
            marginTop: 20,
          }}
        >
          {error}
        </div>
      )}
    </>
  );
};

export default TalkToAgentButton;
